// extracted by mini-css-extract-plugin
export default {"cartBtnClasses":"HeaderCartButton_cartBtnClasses__-bJOa","icon":"HeaderCartButton_icon__OJcs2","badge":"HeaderCartButton_badge__bGT5f"};